export enum LaneOverlapping {
  FrontBrushes = "FrontBrushes",
  RollerBrush = "RollerBrush"
}

export enum WallDistance {
  Far = "Far",
  Near = "Near"
}

export enum DistanceToWall {
  Far = 0.1,
  Near = 0.04,
}

export enum MinimumAisleWidth {
  Narrow = 3,
  Wide = 4,
}
